<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <Row type="flex" align="middle" :gutter="8" style="margin-bottom: 16px">
      <Col span="18">
        <Input
          v-model="bussinessName"
          @input="getTradingBankList"
          placeholder="商品名称"
          clearable
        />
      </Col>
      <Col span="6">
        <Button type="info" long @click="getTradingBankList">获取</Button>
      </Col>
    </Row>

    <!-- 藏宝格：一行 4-5 个 -->
    <div class="xian-grid">
      <div
        v-for="(item, index) in tradingBankList"
        :key="index"
        class="xian-cell"
        :style="{ borderColor: distinguishColor(item.color) }"
      >
        <!-- 顶部标签 -->
        <div class="header">
          <Tag :color="mapColor(item.color)">{{ mapType(item.color) }}</Tag>
          <span class="name">{{ item.goodName }}</span>
        </div>

        <!-- 图片 + 蒙层 -->
        <div class="img-box" :style="{backgroundImage:`url(${randomBg()})`}">
          <span style="text-align: center;font-size: 14px;padding-left: 10px;padding-top: 5px">{{ item.busName }}</span>
          <div class="mask">
            <div class="price">
              <Icon type="ios-pricetags-outline"/>
              {{ item.price }}
            </div>
            <div class="num">数量：{{ item.goodNum }}</div>
          </div>
        </div>

        <!-- 底部信息 -->
        <div class="foot">
          <div class="seller">卖家：{{ item.sellerName }}</div>
          <Button
            type="info"
            long
            size="small"
            @click="purchase(item)"
          >立即购买</Button>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <Page
      :total="total"
      :page-size="pageSize"
      @on-change="changepage"
      style="text-align:center;margin-top:16px"
    />
  </div>
</template>

<script>
export default {
  name: 'XianBaoGe',
  // 原接口、数据、方法 100% 保留
  props: {

  },
  data () {
    return {
      tradingBankList: [],
      total: 0,
      pageSize: 12,
      page:1,
      bussinessName: ''
    }
  },
  methods: {
    getTradingBankList() {
      this.$http.post("gameBussiness/getBussinessList?page=" + this.page + "&pageSize=" + this.pageSize + '&bussinessName=' + this.bussinessName).then((res) => {
        console.error(res.data.rows)
        this.tradingBankList = res.data.rows;
        this.total = res.data.records
      }).catch((err) => {
        this.$Notice.warning({title:"获取黑市失败,请联系管理员"});
      });
    },
    changepage(index) {
      this.page=index;
      this.getTradingBankList()
    },

    purchase(item) {
      this.$http.post(
        "/gameBussiness/playersBuyItem/?charaId=" +
        this.getCookie("charaId") +
        "&buyId=" +
        item.busId
      )
        .then((res) => {
          this.$Notice.warning({title:res.data.msg});

        })
        .catch((err) => {
          this.$Notice.warning({title:"购买失败,请联系管理员"});
        });
    },
    // 品质→文字
    mapType (color) {
      const map = { 1: '普通', 2: '良品', 3: '上品', 4: '极品', 5: '史诗', 6: '传说', 7: '神话' }
      return map[color] || '未知'
    },
    // 品质→iview 标签色
    mapColor (color) {
      const map = { 1: 'default', 2: 'green', 3: 'blue', 4: 'gold', 5: 'purple', 6: 'red', 7: 'orange' }
      return map[color] || 'default'
    },
    // 随机仙纹背景
    randomBg () {
      const arr = [
        'https://img1.baidu.com/it/u=2879432345,1865798118&fm=253&fmt=auto&app=138&f=JPEG?w=640&h=320',
        'https://img0.baidu.com/it/u=2879432345,1865798118&fm=253&fmt=auto&app=138&f=JPEG?w=640&h=320'
      ]
      return arr[Math.floor(Math.random() * arr.length)]
    },
    // 原品质颜色函数保留（可用于边框）
    distinguishColor (color) {
      const map = { 1: '#000', 2: '#c5c52f', 3: 'green', 4: '#1890ff', 5: 'purple', 6: 'red', 7: '#ff8c00' }
      return map[color] || '#ff00c3e0'
    }
  }
}
</script>

<style scoped>
.bg {
  padding: 16px;
  background: #f1f1f1 url('../assets/loginPageDefBg.jpg') center/cover fixed;
}

/* ===== 藏宝格容器 ===== */
.xian-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.xian-cell {
  width: 240px;              /* 一行 5 个（>1200px） */
  background: rgba(255,255,255,0.92);
  border-radius: 8px;
  border: 2px solid transparent;
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
}
.xian-cell:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-color: var(--c);
}

/* ===== 头部 ===== */
.header {
  display: flex;
  align-items: center;
  padding: 8px 12px 0;
}
.header .name {
  margin-left: 8px;
  font-size: 15px;
  font-weight: bold;
  color: #2d8cf0;
}

/* ===== 图片+蒙层 ===== */
.img-box {
  width: 100%;
  height: 90px;
  background-size: cover;
  background-position: center;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #6790a2;
  color: #fff;
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mask .price {
  font-size: 17px;
  font-weight: bold;
}
.mask .num {
  font-size: 12px;
}

/* ===== 底部 ===== */
.foot {
  padding: 8px 12px 12px;
}
.seller {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

/* 响应式：一行 4 个（<1200px） */
@media (max-width: 1200px) {
  .xian-cell { width: 280px; }
}
@media (max-width: 992px) {
  .xian-grid {
    gap: 10px;
  }

  .xian-cell {
    width: calc(50% - 5px);
  }
}

@media (max-width: 480px) {
  .xian-cell {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tradingBank.vue